import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';

import { StyledOption } from './styles';

const formatWithHighlight = (text, query) => {
  if (!query) return text;

  const reg = new RegExp(`(${query})`, 'gi');
  const textParts = text?.split(reg);

  return textParts?.map((part) =>
    part.match(reg) ? (
      <span key={nanoid()} style={{ fontWeight: 'normal' }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};

const Suggestion = ({ value, suggestion, query }) => {
  return (
    <StyledOption value={value}>
      <div>{formatWithHighlight(suggestion.title, query)}</div>
    </StyledOption>
  );
};

Suggestion.propTypes = {
  query: PropTypes.string,
  suggestion: PropTypes.shape({
    title: PropTypes.string.isRequired,
    topic: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};

export default Suggestion;
